import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import {
  rateByIdQueryOptions,
  ratesQueryOptions,
} from '@/core/components/sites/site/rates-and-packages/rates/ratesQueryOptions'
import { addOnsQueryOptions } from '@/core/components/sites/site/rooms/add-ons/addOnsQueryOptions'
import { roomsQueryOptions } from '@/core/components/sites/site/rooms/roomQueryOptions'
import { cancellationPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/policiesQueryOptions'
import { taxAndFeesPoliciesQueryOptions } from '@/core/components/sites/site/site-customization/policies/taxAndFeesQueryOptions'
import { defer, redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/rates-and-packages/rates/create-linked-rate/$linkedRateId/edit/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (auth.user?.role === Role['Front-Desk']) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({
    context: { queryClient, auth },
    params: { linkedRateId, siteId },
  }) => {
    const rooms = defer(
      queryClient.ensureQueryData(roomsQueryOptions(linkedRateId, auth.token!))
    )
    const addOns = defer(
      queryClient.ensureQueryData(addOnsQueryOptions(linkedRateId, auth.token!))
    )
    const taxes = defer(
      queryClient.ensureQueryData(
        taxAndFeesPoliciesQueryOptions(linkedRateId, auth.token!)
      )
    )
    const cancelation = defer(
      queryClient.ensureQueryData(
        cancellationPoliciesQueryOptions(linkedRateId, auth.token!)
      )
    )
    const rates = defer(
      queryClient.ensureQueryData(ratesQueryOptions(siteId, auth.token!))
    )
    const rateById = queryClient.ensureQueryData(
      rateByIdQueryOptions(linkedRateId, auth.token!)
    )

    return {
      rates,
      rooms,
      addOns,
      taxes,
      cancelation,
      rateById,
    }
  },
  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
